// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  return {
          campaignsData: action._0
        };
}

var initialState = {
  campaignsData: /* Init */0
};

export {
  initialState ,
  reducer ,
  
}
/* No side effect */
